<template>
  <div>
    <div v-for="addOn in addOns" :key="addOn.id">
      <div class="col-sm-4">
        <div class="am-addon-inner">
          <div class="am-addon-remove-icon">
            <a @click="confirmDeleteAddOn(addOn.id)" v-if="validUser === true">
              <svg-icon icon="delete" title="Delete" class="am-glyphicon-medium am-glyphicon-blue"></svg-icon>
            </a>
          </div>
          <div class="am-addon-remove-icon-edit">
            <a @click="editAddOnPopUp(addOn)" v-if="validUser === true">
              <svg-icon icon="edit" title="Edit" class="am-glyphicon-medium am-glyphicon-blue"></svg-icon>
            </a>
          </div>
          <div class="row">
            <div class="col-sm-4 text-right am-addon-label">Name:</div>
            <div class="col-sm-8 am-addon-label">{{addOn.name}}</div>
          </div>
          <div class="row">
            <div class="col-sm-4 text-right am-addon-label">Billing Type:</div>
            <div class="col-sm-8 am-addon-label">{{addOn.bill_type}}</div>
          </div>
          <div class="row">
            <div class="col-sm-4 text-right am-addon-label">Base Price:</div>
            <div class="col-sm-8 am-addon-label">
              <span>${{addOn.cost}}</span>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-4 text-right am-addon-label">Client Price:</div>
            <div class="col-sm-8 am-addon-label" >${{officeAmountAfterDiscount(addOn)}}</div>
          </div>
        </div>
      </div>
    </div>
    <modal name="addOn" classes="am-vue-modal" ref="addOn" width="710px" :pivotY="0.5" :scrollable="true" height="auto" :clickToClose="false" :adaptive="true">
      <add-on :is-edit="isEditAddOn" :edit-add-on="editRow"></add-on>
    </modal>
    <modal name="AddOnPopUp" classes="am-vue-modal" :clickToClose="false" height="auto" width="370px" :scrollable="true"  :pivotY="0.5" :adaptive="true">
      <message-popup :confirmDelete="true" @CloseModal="deleteAddOn" modal-name="AddOnPopUp" :errors="messageString" :messageHeader="confirmation"></message-popup>
    </modal>
  </div>
</template>

<script>
import api from './../http'
import MessagePopup from './MessagePopup'
import addOn from '@/components/AddOns'
export default {
  name: 'AddOnListScreen',
  data () {
    return {
      discount_type: 'A',
      confirmation: 'Confirmation',
      messageString: 'Are you sure you want to delete this Add-On?',
      deleteAddOnId: 0,
      isEditAddOn: true,
      editRow: {
        type: Object,
        default: []
      }
    }
  },


  props: {
    acct: Number
  },

  components: {
    MessagePopup,
    addOn,
  },

  asyncComputed: {
    addOns: {
      get () {
        return api.makeRequest('/backoffice/accountAddOnsList/' + this.acct).then(
          (data) => {
            return data.data.results
          }
        )
      },
      default: {}
    },

    validUser: {
      get () {
        return this.$store.dispatch('auth/accountingUser').then(function () {
          return true;
        })
      },
      default: false
    }
  },
  methods: {
    editAddOnPopUp (row) {
      this.editRow = row
      this.$modal.show('addOn')
    },

    deleteAddOn () {
      let self = this
      api.postRequest(`/backoffice/accountAddOnsDelete/` + this.deleteAddOnId, { 'employeeId': this.$store.state.auth.user.id })
        .then(function (response) {
          self.refreshList()
          console.log('response', response)
        }).catch(function (error) {
          console.log(error)
        })
    },

    refreshList: function () {
      this.$asyncComputed.addOns.update()
    },

    confirmDeleteAddOn: function (id) {
      this.deleteAddOnId = id
      this.$modal.show('AddOnPopUp')
    },
    officeAmountAfterDiscount (addOn) {
      let afterDiscount = addOn.cost
      if (addOn.lifetime_discounts !== null && !isNaN(addOn.lifetime_discounts.amount)) {
        afterDiscount -= (addOn.lifetime_discounts.amountType === 'P') ? addOn.lifetime_discounts.amount / 100 * addOn.cost : addOn.lifetime_discounts.amount
      }

      let sortedDiscounts = JSON.parse(JSON.stringify(addOn.discounts))
      sortedDiscounts.sort(function (a, b) {
        if (a.amountType === b.amountType) {
            return 0
        }
        return (a.amountType < b.amountType) ? -1 : 1
      })


      sortedDiscounts.forEach(function (discount) {
        let effDate = moment(discount.effectiveDate, 'YYYY-MM-DD')
        let today = moment(new Date().toISOString().slice(0, 10), 'YYYY-MM-DD')


        if (today.diff(effDate) >= 0 && !isNaN(discount.amount)) {
          afterDiscount -= (discount.amountType === 'P') ? discount.amount / 100 * afterDiscount : discount.amount
        }
      })
        return afterDiscount.toFixed(2)
    }
  }
}
</script>

<style scoped>
  .am-addon-inner {
    background-color: #e2e2e2;
    border:1px solid #CCCCCC;
    color: #777777;
    border-radius: 5px;
    padding: 25px 10px 10px 10px;
    margin-bottom: 20px;
    font-size: 12px;
  }

  .am-addon-label {
    padding: 0px;
  }

  .am-addon-label {
    padding: 0px 0px 0px 10px ;
  }

  .am-addon-remove-icon-edit {
    position: absolute;
    right: 43px;
    top: 10px;
    z-index: 1;
  }

  .am-addon-remove-icon {
    position: absolute;
    right: 20px;
    top: 10px;
    z-index: 1;
  }
  .v--modal-overlay {
    background-color: rgba(0,0,0,0.6) !important;
  }
</style>

<style>
  .am-vue-modal {
    background-color: white;
    text-align: left;
    border-radius: 0;
    box-shadow: 0 20px 60px -2px rgba(27, 33, 58, 0.4);
    padding: 0;
  }
</style>

